//when the user gets to home-images images pop them in one by one
// window.addEventListener('scroll', function() {
//     let images = document.querySelectorAll('.home-images img');
//     let homeImagesSection = document.querySelector('.home-images');
//     let sectionPosition = homeImagesSection.getBoundingClientRect().top;
//     let screenPosition = window.innerHeight / 1.5;

//     if (sectionPosition < screenPosition) {
//         images.forEach((image, index) => {
//             setTimeout(() => {
//                 image.style.opacity = 1;
//                 image.style.animation = `fadeIn 1.5s forwards`;
//             }, index * 500); // Delay each image by 500ms
//         });
//     }
// });
// // Define the fadeIn animation
//   const style = document.createElement('style');
//   style.innerHTML = `
//       @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//       }
//   `;
//   document.head.appendChild(style);

// Sticky header
document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const body = document.body;
    window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
            body.classList.add('header-scroll');
        } else {
            body.classList.remove('header-scroll');
        }
    });
    // get the current width of .header__heading and add it to .header__heading as a style only if window width is 990px or more
    if (window.innerWidth >= 990) {
        const headerHeading = document.querySelector('.header__heading');
        if (headerHeading) {
            const width = headerHeading.offsetWidth;
            headerHeading.style.width = `${width}px`;
        }
    }
});